import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "subheader-block ml-auto demo" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_8 = {
  class: "panel-container show",
  id: "panel-target"
}
const _hoisted_9 = { class: "panel-content contents" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-5 contCnt" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-xl-12" }
const _hoisted_18 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_19 = {
  class: "panel-container show",
  id: "panel-list"
}
const _hoisted_20 = { class: "panel-content contents" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-auto ml-auto" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "gtablecell btnDetCell"
}
const _hoisted_26 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "subheader col-6" }, [
        _createElementVNode("h1", { class: "subheader-title" }, "日報検索")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          disabled: _ctx.btnDisable,
          class: "btn btn-primary waves-effect waves-themed"
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1),
          _createTextVNode("Excel出力 ")
        ]), 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "対象"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "記載者", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_vSelect, {
                    multiple: "",
                    options: _ctx.optionsOp
                  }, null, 8, ["options"])
                ]),
                _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"col-md-1 contTitle\">対象期間</div><div class=\"col-md-5 contCnt input-daterange input-group\"><div class=\"input-daterange input-group\" id=\"datepicker-5\"><input type=\"date\" class=\"form-control\" name=\"start\"><div class=\"input-group-append input-group-prepend\"><span class=\"input-group-text fs-xl\" style=\"height:35px;\">－</span></div><input type=\"date\" class=\"form-control\" name=\"end\"></div></div>", 2))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "種別", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_vSelect, { options: _ctx.opReportStatus }, null, 8, ["options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed btn-search mx-auto",
                  disabled: _ctx.btnDisable
                }, " 検索 ", 8, _hoisted_15)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "日報一覧"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_19, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-primary waves-effect waves-themed mr-1",
                    disabled: _ctx.btnDisable
                  }, " 日付順 ", 8, _hoisted_23),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-primary waves-effect waves-themed mr-1",
                    disabled: _ctx.btnDisable
                  }, " 担当者順 ", 8, _hoisted_24)
                ])
              ]),
              _createVNode(_component_vue_good_table, {
                columns: _ctx.columns,
                rows: _ctx.rows
              }, {
                "table-row": _withCtx((props) => [
                  (props.column.field == 'btnDet')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("a", {
                          href: 
                        '/jyutyuinput?record_id=' + props.row.c_project_number
                      
                        }, _cache[7] || (_cache[7] = [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-xs btn-primary waves-effect waves-themed"
                          }, " 詳細 ", -1)
                        ]), 8, _hoisted_26)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ])
          ])
        ])
      ])
    ])
  ]))
}